import React from 'react';
import { Section } from './ui/Section';
import { Camera } from 'lucide-react';
export function Gallery() {
  // We'll use a mix of aspect ratios for a masonry-ish feel using CSS grid
  const photos = [{
    id: 1,
    class: 'col-span-1 md:col-span-2 row-span-2 aspect-square md:aspect-auto'
  }, {
    id: 2,
    class: 'col-span-1 row-span-1 aspect-square'
  }, {
    id: 3,
    class: 'col-span-1 row-span-1 aspect-square'
  }, {
    id: 4,
    class: 'col-span-1 row-span-2 aspect-[1/2] md:aspect-auto'
  }, {
    id: 5,
    class: 'col-span-1 md:col-span-2 row-span-1 aspect-video md:aspect-auto'
  }, {
    id: 6,
    class: 'col-span-1 row-span-1 aspect-square'
  }];
  return <Section id="gallery" className="bg-tx-secondary border-y border-tx-border" data-id="element-112">
      <div className="text-center mb-16" data-id="element-113">
        <h2 className="text-5xl md:text-7xl text-tx-cream mb-4" data-id="element-114">
          On The <span className="text-tx-red" data-id="element-115">Road</span>
        </h2>
        <div className="w-24 h-1 bg-tx-red mx-auto" data-id="element-116"></div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[200px] md:auto-rows-[250px] gap-4" data-id="element-117">
        {photos.map(photo => <div key={photo.id} className={`relative group overflow-hidden bg-tx-primary border border-tx-border cursor-pointer ${photo.class}`} data-id="element-118">
            {/* Placeholder texture/gradient */}
            <div className="absolute inset-0 bg-gradient-to-br from-tx-primary to-tx-secondary z-0" data-id="element-119"></div>

            {/* Noise overlay for texture */}
            <div className="absolute inset-0 opacity-20 z-10 mix-blend-overlay" style={{
          backgroundImage: 'url(\'data:image/svg+xml,%3Csvg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg"%3E%3Cfilter id="noiseFilter"%3E%3CfeTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="3" stitchTiles="stitch"/%3E%3C/filter%3E%3Crect width="100%25" height="100%25" filter="url(%23noiseFilter)"/%3E%3C/svg%3E\')'
        }} data-id="element-120"></div>

            <div className="absolute inset-0 flex flex-col items-center justify-center z-20 opacity-50 group-hover:opacity-100 transition-opacity duration-300" data-id="element-121">
              <Camera className="w-8 h-8 text-tx-cream/50 group-hover:text-tx-red mb-2 transition-colors" data-id="element-122" />
              <span className="font-heading text-xl tracking-widest text-tx-cream/50 group-hover:text-tx-cream transition-colors" data-id="element-123">
                PHOTO {photo.id}
              </span>
            </div>

            {/* Hover border glow effect */}
            <div className="absolute inset-0 border-2 border-transparent group-hover:border-tx-red/50 transition-colors duration-300 z-30 pointer-events-none" data-id="element-124"></div>
          </div>)}
      </div>
    </Section>;
}